import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { ApiService } from "../../../services/http/api.service";
import { ToastClientService } from "../../../services/toast/toast-client.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RegionProvider } from "../../shared/providers/region.provider";
import { FrequencyProvider } from "../../shared/providers/frequency.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { GeographyProvider } from "../../shared/providers/geography.provider";
import { StateProvider } from "../../shared/providers/state.provider";
import { CityProvider } from "../../shared/providers/city.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { DateFormateService } from 'src/app/services/date-formate.service';

@Component({
  selector: 'app-visibility-submissions',
  templateUrl: './visibility-submissions.component.html',
  styleUrls: ['./visibility-submissions.component.scss']
})
export class VisibilitySubmissionsComponent implements OnInit {

  submissions: any = [];
  id: any;
  selectedData: any = {};
  hideRejected: boolean = true;
  hideActions: boolean = false;
  pageNo = 1;
  pageSize = 5;
  getPaginationCount
  perPage;
  filteredDate: any = {};
  //provider
  regions: any = [];
  channels: any = [];
  geography: any = [];
  states: any = [];
  cities: any = [];
  frequencyList: any = [];
  //filter object data
  formData: any = {
    search_string: '',
    region_id: '',
    channel_id: '',
    geography_id: '',
    state_id: '',
    city_id: '',
    type_id: '',
    start_date: '',
    end_date: ''
  };

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public regionProvider: RegionProvider,
    public frequencyProvider: FrequencyProvider,
    public channelProvider: ChannelProvider,
    public geographyProvider: GeographyProvider,
    public stateProvider: StateProvider,
    public cityProvider: CityProvider,
    public adminDataProvider: AdminDataProvider,
    private formateDate: DateFormateService,

  ) {

  }

  ngOnInit() {
    this.getPaginationValues();
  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
    this.frequencyList = this.frequencyProvider.frequency;
    this.channels = this.channelProvider.channels;
    this.geography = this.geographyProvider.geography;
    this.states = this.stateProvider.state;
    this.cities = this.cityProvider.city;
  }

  getPaginationValues() {
    this.submissions = [];
    let url = this.apiConfig.getVisibilitySubmittedList + this.pageNo + '&program_id=1' + '&search_string=' + this.formData.search_string + '&region_id=' + this.formData.region_id + '&channel_ids=' + this.formData.channel_id + '&geographical_id=' + this.formData.geography_id + '&state_code=' + this.formData.state_id + '&city=' + this.formData.city_id + '&points_type=' + this.formData.type_id + '&start_date=' + this.formData.start_date + '&end_date=' + this.formData.end_date;

    this.apiService.getHeaders(url)
      .subscribe((res: any) => {
        this.submissions = res.body.data
        // this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        this.perPage = res.headers.get('X-Pagination-Per-Page')
        let Pagecount = res.headers.get("X-Pagination-Total-Count");
        this.getPaginationCount =  Math.floor(Pagecount / this.perPage)
        // console.log('::::',this.perPage, Pagecount, this.getPaginationCount);
      }, err => {
        console.log(err);
      })
  }

  filterData() {
    console.log(this.formData);
  }

  setRegion() {
    console.log('region');
    console.log(this.formData.region_id);
  }

  paginationClick(pageNumber) {
    this.pageNo = pageNumber
    this.getPaginationValues();
  }

  //Date range
  selectedDates(dates) {
    if (dates.from) {
      this.filteredDate.start_date = this.formateDate.formateDate(dates.from);
    }
    if (dates.to) {
      this.filteredDate.end_date = this.formateDate.formateDate(dates.to);
    }
    if (!dates.from) {
      this.filteredDate.start_date = '';
    }
    if (!dates.to) {
      this.filteredDate.end_date = '';
    }
    this.formData.start_date = this.filteredDate.start_date;
    this.formData.end_date = this.filteredDate.end_date;
  }

  SubmissionAction(data, modalName) {

    this.hideRejected = true;
    this.hideActions = false;
    this.formData.agent_comments = '';
    this.selectedData = data;
    this.showModal(modalName);
  }

  showModal(modalName) {
    this.modalService.open(modalName, {
      centered: true
    });
  }

  imageAction(action) {
    if (action == 'accept') {
      this.formData.status = 1;
      this.submitAction();
    } else {
      this.formData.status = 2;
      //hide buttons and show the comments section
      this.hideRejected = false;
      this.hideActions = true;
    }
  }

  submitRejection() {
    if (this.formData.agent_comments == undefined) {
      this.toast.Error('Add comments for rejecting')
    } else {
      this.submitAction();
    }
  }

  submitAction() {
    this.formData.program_id = 1;
    // this.formData.posm_master_id = this.selectedData.posm_master_id;
    this.formData.trans_id = this.selectedData.audit_id;

    console.log(this.formData);

    this.apiService.post(this.apiConfig.visibilityApproveOrReject, this.formData)
      .subscribe((res: any) => {
        this.toast.Success('Successfully updated status')
        this.modalService.dismissAll();
        // On Success, we are manually changing the status of the submission, instead of calling the API again.
        let submissionId = this.submissions.findIndex(submission => submission.audit_id === this.formData.trans_id);
        this.submissions[submissionId].status_code = this.formData.status;
        this.submissions[submissionId].agent_comments = this.formData.agent_comments;
      }, err => {
        this.toast.Error('Error performing action')
      })
  }

}
